import '@adornis/bh-matching-frontend-entrypoint/matching-page-admin.js';
import { initAdminRouter } from '@adornis/bh-matching-frontend-entrypoint/matching-page-admin.js';
import { userFieldBlackList } from '@adornis/bh-matching-user/user-field-blacklist.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/forms/x-radiogroup';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { MentoringMentee, MentoringMentor } from '../entities/mentoring-user.js';
import './mentoring-ffm-signup.js';
import './pages/index.js';

export const adminRouter = initAdminRouter({
  configOverrides: {
    'signup-mentee': {
      render: () => html` <mentoring-mentee-signup ${css({ overflowY: 'auto' })}></mentoring-mentee-signup> `,
    },
    ['signup-mentor']: {
      render: () =>
        html`
          <mentoring-mentor-signup
            ${css({ overflowY: 'auto' })}
            page-title=${clientTranslator.translate('mentoring', 'mentorSignupTitle')}
          ></mentoring-mentor-signup>
        `,
    },
    ['matching']: {
      render: () => html`
        <mentoring-page-matching
          .mentorUserClass=${MentoringMentor}
          .menteeUserClass=${MentoringMentee}
        ></mentoring-page-matching>
      `,
    },
    ['matches']: {
      render: () => html`<mentoring-page-manage-matches
        .menteeFieldBlackList=${[...userFieldBlackList, 'foreignLanguages', 'nativeLanguage', 'preferedMentorsIDs']}
        .mentorFieldBlackList=${[...userFieldBlackList, 'foreignLanguages', 'nativeLanguage']}
      ></mentoring-page-manage-matches>`,
    },
    ['admin-users']: {
      render: () => html` <mentoring-page-admin-users></mentoring-page-admin-users> `,
    },
    ['translation-editor']: {
      render: () => html` <mentoring-translation-editor></mentoring-translation-editor> `,
    },
    ['export']: {
      render: () => html` <mentoring-page-export></mentoring-page-export> `,
    },
  },
  // @ts-expect-error
  mentorUserClass: MentoringMentor,
  // @ts-expect-error
  menteeUserClass: MentoringMentee,
});

adminRouter.init();

@customElement('main-element')
export class MainElement extends ChemistryLitElement {
  override render() {
    return html` <matching-page-admin></matching-page-admin> `;
  }
}
